import {Box, Button, IconButton, InputBase, makeStyles, Typography, withStyles} from "@material-ui/core";
import React from "react";
import {FormattedMessage} from "react-intl";

import {
  LanguageActionTypeEnum,
  LanguageState,
  useLanguageDispatch,
  useLanguageState
} from "../../../context/LanguageContext";
import {supportedLanguages} from "../../../components/language/Language";
import styled from "styled-components";
import {SwitchLanguageWrapper} from "../../public/PublicRaffleDrawWinners";

export const LoginButton = withStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.common.white,
    borderRadius: 8,
    fontSize: "1rem",
    padding: "7px 12px",

    "&:hover": {
      backgroundColor: theme.palette.secondary.main,
      opacity: 0.9,
    },

    "&:disabled": {
      opacity: 1.0,
      color: theme.palette.common.white,
      backgroundColor: theme.palette.secondary.main,
    },
  },
  label: {
    textTransform: "none",
  },
}))((props: any) => <Button {...props} />);

export const InputStyled = withStyles((theme) => ({
  root: {
    width: "100%",
    backgroundColor: "rgba(242, 241, 238, 0.3)",
    boxShadow: "rgb(15 15 15 / 10%) 0px 0px 0px 1px inset",
    borderRadius: 4,
    position: 'relative',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
  },
  input: {
    width: "100%",
    height: "38px",
    padding: "0 12px",
    fontSize: "0.86rem",
    fontFamily: theme.typography.fontFamily,
    fontWeight: 500,
    lineHeight: 1.5,
    flexGrow: 1,
    color: theme.palette.text.primary,
    '&:focus': {
      outline: "none",
    },
    '&::placeholder': {
      color: theme.palette.grey[600],
      opacity: 1,
      fontWeight: 400,
    },
    '&:-ms-input-placeholder': {
      color: theme.palette.grey[600],
      opacity: 1,
      fontWeight: 400,
    },
    '&::ms-input-placeholder': {
      color: theme.palette.grey[600],
      fontWeight: 400,
    }
  },
}))(InputBase);

export const InputAdornment = styled("div")`
  margin: 0px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.84rem !important;
`;

export const StyledIconButton = withStyles((theme) => ({
  root: {
    fontSize: "0.84rem !important",
    border: "none",
    cursor: "pointer",
    color: theme.palette.grey[600],
  },
}))(IconButton);

export const languageChooserStyles = makeStyles((theme: any) => ({
  languageWrapper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
}));

export const LanguageChooser = () => {
  const classes = languageChooserStyles();

  return (
      <Box mt={5} className={classes.languageWrapper}>
        <Box component="div" style={{textAlign: "center"}}>
          <Box mb={1}>
            <Typography component="span" style={{fontSize: "0.88rem"}}>
              <FormattedMessage id="sharedScreen.changeLanguage" />
            </Typography>
          </Box>
          <SwitchLanguageWrapper size="small" />
        </Box>
      </Box>
  );
};
